import { useState } from 'react';
import { TitleContainer } from 'componentsV2/ai/header/styled';
import { AIIcon } from '@setvi/shared/components/sicons';
import { SText } from '@setvi/shared/components';
import SearchForm from '@setvi/shared/components/intelligence/product-match/components/form';
import { SearchType } from '@setvi/shared/components/intelligence/search/interfaces';
import { Box } from '@material-ui/core';
import { useFlags } from 'launchdarkly-react-client-sdk';
import { SearchFormOptions } from '@setvi/shared/components/intelligence/product-match/enums';
import {
  ProductMatchValues,
  productMatchValues
} from '@setvi/shared/components/intelligence/product-match';
import { AILogo } from 'componentsV2';
import { HeaderProps } from '../header';

const typeValues = {
  [SearchFormOptions.text]: [ProductMatchValues.Text],
  [SearchFormOptions.url]: [ProductMatchValues.Url],
  [SearchFormOptions.equipment]: [ProductMatchValues.Equipment],
  [SearchFormOptions.image]: [
    ProductMatchValues.Image,
    ProductMatchValues.Description
  ],
  [SearchFormOptions.competitor]: [
    ProductMatchValues.ProductName,
    ProductMatchValues.ManufacturerName,
    ProductMatchValues.ManufacturerSku
  ]
};

interface AskAIInputProps {
  handleSearch: HeaderProps['handleSearch'];
}

export const AskAIInput = ({ handleSearch }: AskAIInputProps) => {
  const [values, setValues] = useState(productMatchValues);
  const [type, setType] = useState<SearchFormOptions>(SearchFormOptions.text);

  const flags = useFlags();

  return (
    <Box px="20px" pb="12px" flex={1}>
      <TitleContainer py="12px">
        <AIIcon style={{ fontSize: 18 }} />
        <SText weight="semibold" title="What can I help you find?" />
      </TitleContainer>
      <SText
        title="AI enables you to effortlessly find similar products within your catalog using various input methods."
        size="sm"
        style={{ marginTop: 4 }}
        noLineClamp
      />
      <Box p={0} mt={3} display="flex">
        <SearchForm
          expanded={false}
          mobileView
          defaultOption={type || SearchFormOptions.text}
          options={[
            SearchFormOptions.text,
            SearchFormOptions.url,
            SearchFormOptions.image,
            ...(flags?.vendorMatch ? [SearchFormOptions.competitor] : [])
          ]}
          values={values}
          onSubmit={value => {
            const filtered = Object.fromEntries(
              Object.entries(values).filter(
                ([key, keyValue]) =>
                  typeof keyValue === 'boolean' ||
                  typeValues[value].includes(key as ProductMatchValues)
              )
            );

            handleSearch({
              type: SearchType.AI,
              search: { ...filtered, value: filtered[value] as string },
              aiType: type
            });
          }}
          urlRows={4}
          textRows={4}
          imageTextRows={2}
          onChange={(newValue: { [key: string]: string }) => {
            const key = Object.keys(newValue)?.[0];
            const newType =
              key === ProductMatchValues.Description ||
              key === ProductMatchValues.Image
                ? SearchFormOptions.image
                : key;

            setType(newType as SearchFormOptions);

            setValues(prev => ({ ...prev, ...newValue }));
          }}
        />
      </Box>
      <Box width="100%" display="flex" justifyContent="center" mt={2}>
        <AILogo fontSize="xs" iconSize={8} />
      </Box>
    </Box>
  );
};
